import { render, staticRenderFns } from "./HowToAbout.vue?vue&type=template&id=5fcd469f&scoped=true&"
import script from "./HowToAbout.vue?vue&type=script&lang=ts&"
export * from "./HowToAbout.vue?vue&type=script&lang=ts&"
import style0 from "./HowToAbout.vue?vue&type=style&index=0&id=5fcd469f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcd469f",
  null
  
)

export default component.exports